import type { TableColumnsType } from 'antd';
import type { EmailTemplateType } from './EmailTemplates.types.ts';
import * as Yup from 'yup';
import { HomeOutlined } from '@ant-design/icons';
import i18n from '../../utils/i18n.ts';

export const EMAIL_TEMPLATES_FORM = 'EmailTemplatesForm';

export const BREADCRUMBS = [
  {
    href: '/',
    title: <HomeOutlined />,
  },
  {
    href: '/',
    title: i18n.t('common.portal'),
  },
  {
    href: '/admin',
    title: i18n.t('pages.admin.title'),
  },
  {
    title: i18n.t('pages.admin.module.email-templates'),
  },
];

export const EMAIL_TEMPLATES_COLUMNS: TableColumnsType<EmailTemplateType> = [
  {
    title: i18n.t('pages.email-templates.name'),
    dataIndex: 'templateId',
  },
  {
    title: i18n.t('pages.email-templates.subject'),
    dataIndex: 'subject',
  },
  {
    title: i18n.t('pages.email-templates.to'),
    dataIndex: 'toAddress',
  },
  {
    title: i18n.t('pages.email-templates.from'),
    dataIndex: 'fromAddress',
  },
  {
    title: i18n.t('pages.email-templates.body'),
    dataIndex: 'bodyTemplate',
    width: 400,
    render: (value: string) => <span dangerouslySetInnerHTML={{ __html: value }} />,
  },
  {
    title: i18n.t('pages.email-templates.is-html'),
    dataIndex: 'isBodyHtml',
    width: 200,
    render: (value: string) => (value ? i18n.t('common.yes') : i18n.t('common.no')),
  },
];

export const EMAIL_TEMPLATES_FORM_SCHEMA = Yup.object().shape({
  title: Yup.string().required(i18n.t('error.validation.required-name')),
  subject: Yup.string().required(i18n.t('error.validation.required-subject')),
  to: Yup.string().email(i18n.t('error.validation.valid-email')),
  from: Yup.string().email(i18n.t('error.validation.valid-email')),
  body: Yup.string().required(i18n.t('error.validation.required-body')),
  isHtml: Yup.boolean(),
});

export const EMAIL_TEMPLATES_INITIAL_FORM_VALUES = {
  id: null,
  title: '',
  subject: '',
  to: '',
  from: '',
  body: '',
  isHtml: true,
};
